export default __webpack_public_path__ + "static/media/fantom.bc3e5519.svg";